import { FC, useState } from "react";
import KickImage from 'Reuseables/KickImage';

//Components
import Component from "./Component";

//Action
import { createOrder } from "../../../../actions/shipperAction";

//Helpers
import { printError } from "../../../../utils/Helpers";

//Types
import { OrderCreatedInterface } from "../definitions";
import { WrapperInterface } from "./definitions";

const LogisticConfirmation: FC<WrapperInterface> = ({
  selectedLogistic,
  sale_id,
  seller_shipping_id,
  isConsignments,
  onBack,
  continueAction
}) => {
  if (!selectedLogistic) return null;

  const { logistic, rate, max_day, min_day, must_use_insurance, total_price, insurance_fee, base_price } = selectedLogistic;
  const oneEta = max_day == min_day;

  const [check, setCheck] = useState<boolean>(must_use_insurance || false);
  const [loading, setLoading] = useState(false)
  const [toastMessage, setToastMessage] = useState("")

  const totalPrice = check ? base_price + insurance_fee : base_price;

  //Handlers
  const setCheckHander = () => !must_use_insurance && setCheck(!check)

  const confirmHandler = async () => {
    try {
      setLoading(true)
      const payload = {
        seller_shipping_id,
        courier: {
          name: logistic?.name,
          type: rate?.type,
          price: total_price,
          cod: false,
          rate_id: rate?.id,
          use_insurance: check,
          insurance_fee,
          min_day,
          max_day
        },
        coverage: "domestic"
      }
      if (isConsignments) {
        payload['sell_consignment_id'] = sale_id;
      } else {
        payload['sale_id'] = sale_id
      }
      await createOrder(payload)
        .then(res => res?.data)
        .then((res) => {
          const data: OrderCreatedInterface = res.data;
          continueAction(data)
        })
        .catch(err => { throw err })
        .finally(() => {
          setLoading(false)
        })
    } catch (err) {
      const errMsg = printError(err);
      setLoading(false)
      setToastMessage(errMsg)
      console.log(err, "Failed to create order")
    }
  }

  const resetToastMessage = () => setToastMessage("");

  return (
    <Component
      logistic={logistic}
      rate={rate}
      max_day={max_day}
      min_day={min_day}
      final_price={totalPrice}
      insurance_fee={insurance_fee}
      base_price={base_price}
      oneEta={oneEta}
      loading={loading}
      check={check}
      toastMessage={toastMessage}
      must_use_insurance={must_use_insurance}
      resetToastMessage={resetToastMessage}
      setCheckHander={setCheckHander}
      confirmHandler={confirmHandler}
      onBack={onBack}
    />
  )
}
LogisticConfirmation.defaultProps = {
  selectedLogistic: null,
  continueAction: () => { },
  onBack: () => { }
}

export default LogisticConfirmation;